import { API_URL, requestHeader } from '../constants/ApiConfiguration'

export function fetchHome() {
    return fetch(API_URL + '/home-beta', {
        method: 'GET', 
        headers: requestHeader()
    }).then(response => response.json()) 
}